import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';
import { EditIcon, Link } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';

import { DocplannerUpdateClientSecretModal } from './DocplannerUpdateClientSecretModal';

type DocplannerUpdateSynchronizationDaysCountProps = {
   readonly apiKey: string;
};

export const DocplannerUpdateClientSecret = (props: DocplannerUpdateSynchronizationDaysCountProps): ReactElement => {
   const [
      { setTrue: openUpdateClientSecretModal, setFalse: closeUpdateClientSecretModal },
      updateClientSecretModalOpened,
   ] = useBoolean(false);

   return (
      <>
         <Link
            testId={'updateClientSecret'}
            label={integrationTranslationKeys.updateApiSecret}
            onClick={openUpdateClientSecretModal}
            icon={<EditIcon />}
         />
         {updateClientSecretModalOpened ? (
            <DocplannerUpdateClientSecretModal apiKey={props.apiKey} onClose={closeUpdateClientSecretModal} />
         ) : null}
      </>
   );
};
